module.exports = __webpack_public_path__ + "static/img/usBottom1.49c52a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/usBottom1.png
// module id = FA0M
// module chunks = 2